var Brand;
(function (Brand) {
  Brand["apc"] = "APC";
  Brand["se"] = "SE";
  Brand["default"] = "SE";
})(Brand || (Brand = {}));
const brandResources = {
  [Brand.se]: {
    name: Brand.se,
    pdfBottomLogo: {
      src: 'PES/assets/images/schneider_LIO_Life-Green_RGB.png',
      alt: 'Life Is On Logo',
    },
  },
  [Brand.apc]: {
    name: Brand.apc,
    pdfBottomLogo: {
      src: 'PES/assets/images/APC_logo.png',
      alt: 'Life Is On Logo',
    },
  },
};

export { Brand as B, brandResources as b };
